<template>
  <div class="text-block block-card card-border">
    <v-expansion-panel :value="panel" expand>
      <v-expansion-panel-content :lazy="lazyRendering">
        <template v-slot:header>
          <div class="block-card-title handle">
            <div class="title-icon">
              <span class="botter-user-input-icon white--text text-lg-2" />
            </div>

            <h4>
              Multiline Input
              <v-icon
                v-if="errorsCount && errorsCount.errorsCount"
                color="error"
                style="margin-left: 4px"
                >error</v-icon
              >
              <span class="text--error" v-if="!validData"
                >(Invalid Card Data)</span
              >
            </h4>
          </div>
        </template>
        <form-validation v-model="errorsCount">
          <div class="block-card-body" v-if="validData">
            <label>Message To User</label>
            <!--                                <v-text-field-->
            <!--                                        outline-->
            <!--                                        v-model="item.message"-->
            <!--                                        :error="!item.message"-->
            <!--                                        :error-messages="!item.message? 'Message To User is Required':'' "-->
            <!--                                >-->
            <!--                                </v-text-field>-->
            <vTextareaAutocomplete
              v-model="data.message"
              :type="'textarea'"
              :counter="1000"
              :validation-rules="autocompleteUserInputMessageValidationRules"
            />

            <label>Save Answer To Attribute</label>
            <v-text-field
              v-model="data.save_to_attribute"
              :error="!data.save_to_attribute"
              :error-messages="
                !data.save_to_attribute ? 'Attribute is Required' : ''
              "
              outline
            />

            <label>Stop Word</label>
            <v-text-field
              v-model="data.stopWord"
              :error="!data.stopWord"
              :error-messages="!data.stopWord ? 'stop Word is Required' : ''"
              outline
            />

            <v-flex xs12>
              <label>Display Stop Button</label>
              <v-switch v-model="data.displayStopButton" />
            </v-flex>
          </div>
        </form-validation>
        <slot name="tail" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import common from "../../../../utils/common";
import FormValidation from "../FormValidation";
export default {
  name: "CardMultiInput",
  components: {
    FormValidation,
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    index: {
      type: Number,
      default: () => {
        return 0;
      },
    },
    blocksList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    validData: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      errorsCount: { errorsCount: 0 },
      lazyRendering: true,
      valid: true,
      panel: 1,
      common,
      validationList: [
        { name: "Text", value: "text" },
        { name: "Number", value: "number" },
        { name: "Email", value: "email" },
        { name: "User Attribute", value: "userAttribute" },
        { name: "Other", value: "other" },
      ],
      autocompleteUserInputMessageValidationRules: [
        (v) => !!v || "Message to user is Required",
      ],
      autocompleteUserErrorMessageValidationRules: [
        (v) => !!v || "Error Message is Required",
      ],
    };
  },
  computed: {},
  watch: {
    errorsCount(val) {
      this.$emit("input", { errorsCount: val.errorsCount });
      this.data.errorsCount = val.errorsCount;
    },
  },
  mounted() {
    if (this.data.errorsCount !== undefined) {
      this.errorsCount = this.data.errorsCount;
    } else {
      // disabling Lazy rendering so we can grip errors count
      this.lazyRendering = false;
      setTimeout(() => {
        // then we turn it on again to keep the performance up
        this.lazyRendering = true;
      }, 1000);
    }
  },
  methods: {},
};
</script>

<style scoped></style>
